import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/administration/products/")({
  beforeLoad: () => {
    throw redirect({ to: "/workspace/products" });
  },
});
